export class Adorner {
    constructor(
        public ID: string,
        public Location: string,
        public Color: string,
        public Icon: string,
        public IconURL: string,
        public VisibilityCriteria: string,
        public Order: number
    ) { }
}